/**
 * For recurring events (same recurringGroupId), only keep the soonest one.
 * Non-recurring events pass through unchanged.
 * Expects events sorted by date ascending.
 */
export function deduplicateRecurring(events) {
  const seen = new Set();
  return events.filter(event => {
    const groupId = event.recurringGroupId;
    if (!groupId) return true; // not recurring — keep
    if (seen.has(groupId)) return false; // already showed the soonest one
    seen.add(groupId);
    return true;
  });
}
